import {
  faPlusCircle,
  faSpinner,
  faShareAltSquare,
  faList,
} from '@fortawesome/free-solid-svg-icons';

import {
  faArrowUpRightFromSquare
} from '@fortawesome/pro-regular-svg-icons'

import {
  faSort,
  faSortDown,
  faSortUp,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faExclamationCircle,
  faInbox,
  faSignOutAlt,
  faUser,
  faCalendar,
  faCalendarPlus,
  faPhoneSquare,
  faEnvelope,
  faCaretRight,
  faCaretLeft,
  faUserFriends,
  faUsers,
  faCommentAlt,
  faVideo,
  faHistory,
  faFileAlt,
  faFileDownload,
  faFileUpload,
  faCheckCircle,
  faInfoSquare,
  faTimesCircle,
  faQuestionCircle,
  faUpload,
  faEdit,
  faCreditCard,
  faReply,
  faTrash,
  faUndo,
  faSearch,
  faCheck,
  faTimes as faTimesRegular,
  faPlus,
  faEllipsisV,
  faIdCard,
  faStar,
  faSlidersV,
  faComment,
  faCommentLines,
  faComments,
  faPhone,
  faClock,
  faUniversity,
  faEnvelopeSquare,
  faUserSecret,
  faLongArrowAltRight,
  faShareSquare,
  faCircle,
  faTachometer,
  faExclamationTriangle,
  faEye,
  faDownload,
  faMinus,
  faSyncAlt,
  faUserTag,
  faArrowRight,
  faArrowLeft,
  faPenToSquare,
  faNoteSticky,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faBars,
  faTimes,
} from '@fortawesome/pro-light-svg-icons';

const fontAwesomeIcons = [
  faPlusCircle,
  faBars,
  faTimes,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faExclamationCircle,
  faExclamationTriangle,
  faInbox,
  faSignOutAlt,
  faUser,
  faCalendar,
  faCalendarPlus,
  faPhoneSquare,
  faEnvelope,
  faCaretRight,
  faCaretLeft,
  faUserFriends,
  faUsers,
  faCommentAlt,
  faVideo,
  faHistory,
  faFileAlt,
  faFileDownload,
  faFileUpload,
  faCheckCircle,
  faInfoSquare,
  faTimesCircle,
  faQuestionCircle,
  faUpload,
  faEdit,
  faCreditCard,
  faReply,
  faTrash,
  faUndo,
  faSearch,
  faCheck,
  faTimesRegular,
  faPlus,
  faEllipsisV,
  faIdCard,
  faStar,
  faSlidersV,
  faComment,
  faComments,
  faCommentLines,
  faPhone,
  faClock,
  faUniversity,
  faEnvelopeSquare,
  faUserSecret,
  faShareSquare,
  faShareAltSquare,
  faLongArrowAltRight,
  faCircle,
  faTachometer,
  faEye,
  faDownload,
  faMinus,
  faSyncAlt,
  faList,
  faUserTag,
  faArrowRight,
  faArrowLeft,
  faPenToSquare,
  faNoteSticky,
  faArrowUpRightFromSquare
];
export default fontAwesomeIcons;
